module.exports = __webpack_public_path__ + "static/media/019.4bab8abc.jpg";